import react, { useEffect, useState } from 'react';
import useAxios from '../../Hooks/use-axios';
import { getConfig } from '../../utils/config';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../store/auth-slice';
import { useLocation, useParams, useRouteMatch } from 'react-router-dom';
import useSearchInput from '../../Hooks/useSearchInput';
import store from '../../store';
import { dealAction } from '../../store/deal-slice'; // Ensure you have the actions to save bundle deals

import {
    cmsClient,
    deleteWinnreAuthToken,
    winnreAuth
} from '../../utils/axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getKYCStatus } from '../../helpers';
import useBookingSummary from '../../Hooks/use-bookingSummary';

const useData = ({isRewards, isBundle}) => {
    const [topOffers, setTopOffers] = useState([]);
    const [benefits, setBenefits] = useState([]);
    const [moveInOffers, setMoveInOffers] = useState([]);
    const [financeOffers, setFinanceOffers] = useState([]);
    const [externalOffers, setExternalOffers] = useState([]);
    const [digitalAmenities, setDigitalAmenities] = useState([]);
    const [bundleOffers, setBundleOffers] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [kycStatus, setKycStatus] = useState('');
    // const [rewards, setRewards] = useState([]);
    // const [TV, setTV] = useState([]);
    // const [WashingMachine, setWashingMachine] = useState([]);
    // const [Fridge, setFridge] = useState([]);
    // const[microWave , setMicroWave]=useState([]);
    // const[airConditioner , setAirConditioner]=useState([]);
    const [tVs, setTVs] = useState([]);
    const [washingMachines, setWashingMachines] = useState([]);
    const [fridges, setFridges] = useState([]);
    const [microwaves, setMicrowaves] = useState([]);
    const [airConditioners, setAirConditioners] = useState([]);
    // const [tagList, setTagList] = useState([]);
    // const [selectedTag, setSelectedTag] = useState(null);
    // const [totalPages, setTotalPages] = useState(0);
    // const [currentPage, setCurrentPage] = useState(0);
    const [rewards, setrewards] = useState([]);
    const [isRewardsLoaded, setIsRewardsLoaded] = useState(false);
    const location = useLocation();
    const history = useHistory();

    const [cartAmount, setCartAmount] = useState(0);
    const [rewardsCategoryList, setRewardsCategoryList] = useState([]);

    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const token = useSelector((state) => state.auth.token);
    const isRewardRefreshing = useSelector(
        (state) => state.deals.isRefreshRewards
    );
    const totalRewardspoint = useSelector((state) => state.auth.rewardPoints);
    console.log('USER REWARD POINTS STORE', totalRewardspoint);
    const totalRewardsLength = useSelector((state) => state.auth.totalRewards);
        console.log('USER REWARDS LENGTH', totalRewardsLength);
    const queryParams = new URLSearchParams(location.search);
    const tagID = queryParams.get('tagid');
    const rewardCategoryID = queryParams.get('rewardCategoryId');
    // Set initial selected category from URL (if present), else null
    const [selectedRewardCategory, setSelectedRewardCategory] = useState(
        rewardCategoryID ? Number(rewardCategoryID) : null
    );

    useEffect(() => {
        if (rewardCategoryID) {
            setSelectedRewardCategory(Number(rewardCategoryID));
        }
    }, [rewardCategoryID]);

    const state = store.getState(); // Access the current store state
    useEffect(() => {
        if (tagID == Number(65)) {
            history.push('/bundle-deals');
        }
    }, [tagID]);

    // useEffect(() => {
    //     if (isAuthenticated) {
    //         getUserAccountSummary();
    //     }
    // }, [isAuthenticated]);

    const callback = (searchValue) => {
        window?.webengage?.track('OfferSearch', {
            'Keyword ': `${searchValue}`
        });
        getLifestyleOffers();
        getMoveInOffers();
        getFinanceOffers();
        getExternalOffers();
        getDigitalAmenities();
        getBundleOffers();
        getRewards();
    };
    const [searchInput, handleChange] = useSearchInput('', callback);
    const [unauthorizedUserMessage, setUnauthorizedUserMessage] =
        useState(null);
    // const [userAccountSummary, setUserAccountSummary] = useState(null);
    const dispatch = useDispatch();
    const { userAccountSummary, getUserAccountSummary } = useBookingSummary();
    const isInternalWebview = useSelector(
        (state) => state.webView.internalWebview
    );

    const config = getConfig();

    const logout = () => {
        setBenefits([]);
        setMoveInOffers([]);
        setFinanceOffers([]);
        setExternalOffers([]);
        setDigitalAmenities([]);
        window?.webengage?.track('LogOut');
        window?.webengage?.user?.logout();
        if (config?.autoLogout) {
            sessionStorage.removeItem('refreshToken');
            sessionStorage.removeItem('accessToken');
        } else {
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
        }
        deleteWinnreAuthToken();
        dispatch(authActions.logout());
        dispatch(dealAction.clearAllCaches());
    };

    const {
        isLoading: isLoadingBenefits,
        error,
        sendRequest: fetchBenefits
    } = useAxios();

    const { isLoading: isLoadingTopDeals, sendRequest: fetchTopOffers } =
        useAxios();
    const { isLoading: isLoadingFinance, sendRequest: fetchFinanceOffers } =
        useAxios();
    const { isLoading: isLoadingExternal, sendRequest: fetchExternalOffers } =
        useAxios();
    const { isLoading: isLoadingMovein, sendRequest: fetchMoveInOffers } =
        useAxios();
    const { isLoading: isLoadingDigital, sendRequest: fetchDigitalAmenities } =
        useAxios();
    const { isLoading: isLoadingBundle, sendRequest: fetchBundleOffers } =
        useAxios();
    const { isLoading: isLoadingrewards, sendRequest: fetchrewards } =
        useAxios();
    const {
        isLoading: isLoadingRewardsCategory,
        sendRequest: fetchRewardsCategory
    } = useAxios();
    const date = moment().format();

    //Get account summary data
    // const getUserAccountSummary = () => {
    //     winnreAuth({
    //         method: 'get',
    //         url: '/winnre/user/booking/account-summary'
    //     })
    //         .then((res) => {
    //             setUserAccountSummary(res);
    //         })
    //         .catch((e) => {
    //             setUserAccountSummary(null);
    //         });
    // };

    const getBundleOffers = () => {
        // console.log('TOP OFFERS');

        let bundleUrl;
        if (isAuthenticated) {
            bundleUrl = `/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&categoryList=8&pageSize=10${
                searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
            }${isRewards ? `&rewardsPage=true` : ''}`;
        } else {
            bundleUrl = `/cms_service/deals/filter-v2?isVisibleToAll=true&status=PUBLISHED&clientId=${
                config?.id
            }&pageSize=10&isAscending=false&sortBy=priority&categoryList=8${
                searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
            }${isRewards ? `&rewardsPage=true` : ''}${
                isRewards ? `&rewardsPage=true` : ''
            }`;
        }
        let bundleOffer = state.deals.bundleOffers[bundleUrl] || null;
        const url = bundleUrl + `&endDate=${date}`;
        let method = 'get';
        if (bundleOffer) {
            console.log('Using cached bundleOffer deals:', bundleOffer);
            setBundleOffers(bundleOffer);
        } else {
            fetchBundleOffers(
                {
                    isEncryptedResponse: isAuthenticated ? true : false,
                    url,
                    method,
                    isFormData: true
                },
                (data) => {
                    console.log('bundle offers all', data);
                    if (isAuthenticated) {
                        if (
                            data?.status === 'UNAUTHORIZED' ||
                            data?.status === 'FAILED'
                        ) {
                            setBundleOffers([]);
                            dispatch(
                                dealAction.removeBundleOffersDealsByUrl({
                                    url: bundleUrl
                                })
                            );
                            toast.error('Failed to load bundle offers');
                            return;
                        }
                        if (
                            data?.status === 'TOKEN_EXPIRED' ||
                            data?.status === 'INVALID_TOKEN'
                        ) {
                            if (isInternalWebview) {
                                dispatch(
                                    authActions.setUnauthorizedUser(
                                        data.message
                                    )
                                );
                                return;
                            }
                            logout();
                            return;
                        }
                    }
                    dispatch(
                        dealAction.saveBundleOffersDeals({
                            url: bundleUrl,
                            deals: data?.content || []
                        })
                    );
                    setBundleOffers(data?.content || []);
                }
            );
        }
    };

    const getTopOffers = () => {
        console.log('TOP OFFERS');

        let topUrl;
        if (isAuthenticated) {
            topUrl = `/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&categoryList=1,2,3,5&pageSize=10&tagList=52${
                isRewards ? `&rewardsPage=true` : ''
            }`;
        } else {
            topUrl = `/cms_service/deals/filter-v2?isVisibleToAll=true&tagList=52&status=PUBLISHED&clientId=${
                config?.id
            }&pageSize=10&isAscending=false&sortBy=priority&categoryList=1,2,3,5${
                isRewards ? `&rewardsPage=true` : ''
            }`;
        }
        let method = 'get';
        let topOffers = state.deals.topOffers[topUrl] || null;
        const url = topUrl + `&endDate=${date}`;
        if (topOffers) {
            console.log('Using cached top deals:', topOffers);
            setTopOffers(topOffers);
        } else {
            fetchTopOffers(
                {
                    isEncryptedResponse: isAuthenticated ? true : false,
                    url,
                    method,
                    isFormData: true
                },
                (data) => {
                    if (isAuthenticated) {
                        if (
                            data?.status === 'UNAUTHORIZED' ||
                            data?.status === 'FAILED'
                        ) {
                            setTopOffers([]);

                            toast.error('Failed to load offers of the month');

                            return;
                        }
                        if (
                            data?.status === 'TOKEN_EXPIRED' ||
                            data?.status === 'INVALID_TOKEN'
                        ) {
                            if (isInternalWebview) {
                                dispatch(
                                    authActions.setUnauthorizedUser(
                                        data.message
                                    )
                                );
                                return;
                            }
                            logout();
                            return;
                        }
                    }
                    dispatch(
                        dealAction.saveTopOffersDeals({
                            url: topUrl,
                            deals: data?.content || []
                        })
                    );
                    setTopOffers(data?.content || []);
                }
            );
        }
    };

    const getVendors = () => {
        cmsClient({
            method: 'GET',
            url: `/cms_service/vendors/getAllByFilter?clientId=${
                config?.id
            }&pageSize=30&categoryIds=1,2,3,5,8${
                isRewards ? `&rewardsPage=true` : ''
            }`
        }).then((res) => {
            console.log('vendor data', res);

            if (
                res?.status === 'TOKEN_EXPIRED' ||
                res?.status === 'INVALID_TOKEN'
            ) {
                if (isInternalWebview) {
                    dispatch(authActions.setUnauthorizedUser(res.message));
                    return;
                }
                logout();
                return;
            }

            setVendors(res?.data?.content);
        });
    };

    const getLifestyleOffers = () => {
        // console.log('LIFESTYLE BENEFITS');

        let benefitUrl;
        if (isAuthenticated) {
            benefitUrl = `/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=5&categoryList=1${
                searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
            }${isRewards ? `&rewardsPage=true` : ''}`;
        } else {
            benefitUrl = `/cms_service/deals/filter-v2?isVisibleToAll=true&&status=PUBLISHED&clientId=${
                config?.id
            }&pageSize=5&isAscending=false&sortBy=priority&categoryList=1${
                searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
            }${isRewards ? `&rewardsPage=true` : ''}`;
        }
        let method = 'get';
        let benefitOffers = state.deals.benefitsOffers[benefitUrl] || null;
        const url = benefitUrl + `&endDate=${date}`;
        if (benefitOffers) {
            console.log('Using cached benefitOffers deals:', benefitOffers);
            setBenefits(benefitOffers);
        } else {
            fetchBenefits(
                {
                    isEncryptedResponse: isAuthenticated ? true : false,
                    url,
                    method,
                    isFormData: true
                },
                (data) => {
                    // console.log('data', data);
                    if (isAuthenticated) {
                        if (
                            data?.status === 'UNAUTHORIZED' ||
                            data?.status === 'FAILED'
                        ) {
                            setUnauthorizedUserMessage(
                                data?.status === 'UNAUTHORIZED'
                                    ? 'Become our customer to avail deals.'
                                    : 'Something went wrong. Could not load offers. Please try again!'
                            );
                            toast.error('Failed to load member benefits');
                            dispatch(
                                dealAction.removeBenefitsOffersDealsByUrl({
                                    url: benefitUrl
                                })
                            );
                            setBenefits([]);
                            return;
                        }
                        if (
                            data?.status === 'TOKEN_EXPIRED' ||
                            data?.status === 'INVALID_TOKEN'
                        ) {
                            if (isInternalWebview) {
                                dispatch(
                                    authActions.setUnauthorizedUser(
                                        data.message
                                    )
                                );
                                return;
                            }
                            logout();
                            return;
                        }
                    }
                    dispatch(
                        dealAction.saveBenefitsoffersDeals({
                            url: benefitUrl,
                            deals: data?.content || []
                        })
                    );
                    setBenefits(data.content || []);
                }
            );
        }
    };

    const getMoveInOffers = () => {
        // console.log('move in');

        let moveInUrl;
        // console.log('TGAS WHEN GETTING DEALS', selectedCategories);
        if (isAuthenticated) {
            moveInUrl = `/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=5&categoryList=2${
                searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
            }${isRewards ? `&rewardsPage=true` : ''}`;
        } else {
            moveInUrl = `/cms_service/deals/filter-v2?isVisibleToAll=true&&status=PUBLISHED&clientId=${
                config?.id
            }&pageSize=5&isAscending=false&sortBy=priority&categoryList=2${
                searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
            }${isRewards ? `&rewardsPage=true` : ''}`;
        }
        let method = 'get';
        let moveInOffer = state.deals.moveInOffers[moveInUrl] || null;
        const url = moveInUrl + `&endDate=${date}`;
        if (moveInOffer) {
            console.log('Using cached moveInOffers deals:', moveInOffer);
            setMoveInOffers(moveInOffer);
        } else {
            fetchMoveInOffers(
                {
                    isEncryptedResponse: isAuthenticated ? true : false,
                    url,
                    method,
                    // headers: isAuthenticated ? headers2 : '',
                    // data: data1,
                    isFormData: true
                },
                (data) => {
                    // console.log('DEAL DATA', data);
                    if (isAuthenticated) {
                        if (
                            data?.status === 'UNAUTHORIZED' ||
                            data?.status === 'FAILED'
                        ) {
                            // console.log('failed');

                            setUnauthorizedUserMessage(
                                data?.status === 'UNAUTHORIZED'
                                    ? 'Become our customer to avail deals.'
                                    : 'Something went wrong. Could not load offers. Please try again!'
                            );
                            toast.error('Failed to load move in offers');

                            setMoveInOffers([]);
                            return;
                        }
                        if (
                            data?.status === 'TOKEN_EXPIRED' ||
                            data?.status === 'INVALID_TOKEN'
                        ) {
                            if (isInternalWebview) {
                                dispatch(
                                    authActions.setUnauthorizedUser(
                                        data.message
                                    )
                                );
                                return;
                            }
                            logout();
                            return;
                        }
                    }
                    dispatch(
                        dealAction.saveMoveInOffersDeals({
                            url: moveInUrl,
                            deals: data?.content || []
                        })
                    );
                    setMoveInOffers(data.content || []);
                }
            );
        }
    };
    const getFinanceOffers = () => {
        // console.log('FINANCE');
        let financeUrl;
        if (isAuthenticated) {
            financeUrl = `/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=5&categoryList=3${
                searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
            }${isRewards ? `&rewardsPage=true` : ''}`;
        } else {
            financeUrl = `/cms_service/deals/filter-v2?isVisibleToAll=true&&status=PUBLISHED&clientId=${
                config?.id
            }&pageSize=5&isAscending=false&sortBy=priority&categoryList=3${
                searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
            }${isRewards ? `&rewardsPage=true` : ''}`;
        }
        let method = 'get';
        let financeOffers = state.deals.financeOffers[financeUrl] || null;
        const url = financeUrl + `&endDate=${date}`;
        if (financeOffers) {
            console.log('Using cached finance deals:', financeOffers);
            setFinanceOffers(financeOffers);
        } else {
            fetchFinanceOffers(
                {
                    isEncryptedResponse: isAuthenticated ? true : false,
                    url,
                    method,
                    isFormData: true
                },
                (data) => {
                    if (isAuthenticated) {
                        if (
                            data?.status === 'UNAUTHORIZED' ||
                            data?.status === 'FAILED'
                        ) {
                            setUnauthorizedUserMessage(
                                data?.status === 'UNAUTHORIZED'
                                    ? 'Become our customer to avail deals.'
                                    : 'Something went wrong. Could not load offers. Please try again!'
                            );
                            toast.error('Failed to load home financing deals');

                            setFinanceOffers([]);
                            return;
                        }
                        if (
                            data?.status === 'TOKEN_EXPIRED' ||
                            data?.status === 'INVALID_TOKEN'
                        ) {
                            if (isInternalWebview) {
                                dispatch(
                                    authActions.setUnauthorizedUser(
                                        data.message
                                    )
                                );
                                return;
                            }
                            logout();
                            return;
                        }
                    }
                    dispatch(
                        dealAction.saveFinanceOffersDeals({
                            url: financeUrl,
                            deals: data?.content || []
                        })
                    );
                    setFinanceOffers(data.content || []);
                }
            );
        }
    };

    const getExternalOffers = () => {
        // console.log('FINANCE');
        let externalUrl;
        if (isAuthenticated) {
            externalUrl = `/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=5&categoryList=9${
                searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
            }${isRewards ? `&rewardsPage=true` : ''}`;
        } else {
            externalUrl = `/cms_service/deals/filter-v2?isVisibleToAll=true&&status=PUBLISHED&clientId=${
                config?.id
            }&pageSize=5&isAscending=false&sortBy=priority&categoryList=9${
                searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
            }${isRewards ? `&rewardsPage=true` : ''}`;
        }
        let method = 'get';
        let externalOffers = state.deals.externalOffers[externalUrl] || null;
        const url = externalUrl + `&endDate=${date}`;
        if (externalOffers) {
            console.log('Using cached finance deals:', externalOffers);
            setExternalOffers(externalOffers);
        } else {
            fetchExternalOffers(
                {
                    isEncryptedResponse: isAuthenticated ? true : false,
                    url,
                    method,
                    isFormData: true
                },
                (data) => {
                    console.log('external APII', data);
                    if (isAuthenticated) {
                        if (
                            data?.status === 'UNAUTHORIZED' ||
                            data?.status === 'FAILED'
                        ) {
                            setUnauthorizedUserMessage(
                                data?.status === 'UNAUTHORIZED'
                                    ? 'Become our customer to avail deals.'
                                    : 'Something went wrong. Could not load offers. Please try again!'
                            );
                            toast.error('Failed to load home financing deals');

                            setExternalOffers([]);
                            return;
                        }
                        if (
                            data?.status === 'TOKEN_EXPIRED' ||
                            data?.status === 'INVALID_TOKEN'
                        ) {
                            if (isInternalWebview) {
                                dispatch(
                                    authActions.setUnauthorizedUser(
                                        data.message
                                    )
                                );
                                return;
                            }
                            logout();
                            return;
                        }
                    }
                    dispatch(
                        dealAction.saveExternalOffersDeals({
                            url: externalUrl,
                            deals: data?.content || []
                        })
                    );
                    setExternalOffers(data.content || []);
                }
            );
        }
    };

    const getDigitalAmenities = () => {
        // console.log('DIGITAL AMENITIES');
        let digitalUrl;
        if (isAuthenticated) {
            digitalUrl = `/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=5&categoryList=5${
                searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
            }${isRewards ? `&rewardsPage=true` : ''}`;
        } else {
            digitalUrl = `/cms_service/deals/filter-v2?isVisibleToAll=true&&status=PUBLISHED&clientId=${
                config?.id
            }&pageSize=5&isAscending=false&sortBy=priority&categoryList=5${
                searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
            }${isRewards ? `&rewardsPage=true` : ''}`;
        }
        let method = 'get';
        const url = digitalUrl + `&endDate=${date}`;
        let digitalAmenity = state.deals.digitalAmenities[digitalUrl] || null;
        if (digitalAmenity) {
            console.log('Using cached digitalAmenities deals:', digitalAmenity);
            setDigitalAmenities(digitalAmenity);
        } else {
            fetchDigitalAmenities(
                {
                    isEncryptedResponse: isAuthenticated ? true : false,
                    url,
                    method,
                    isFormData: true
                },
                (data) => {
                    console.log('Amenitiesdata', data);
                    if (isAuthenticated) {
                        if (
                            data?.status === 'UNAUTHORIZED' ||
                            data?.status === 'FAILED'
                        ) {
                            setUnauthorizedUserMessage(
                                data?.status === 'UNAUTHORIZED'
                                    ? 'Become our customer to avail deals.'
                                    : 'Something went wrong. Could not load offers. Please try again!'
                            );
                            toast.error('Failed to load digital amenities');

                            setBenefits([]);
                            return;
                        }
                        if (
                            data?.status === 'TOKEN_EXPIRED' ||
                            data?.status === 'INVALID_TOKEN'
                        ) {
                            if (isInternalWebview) {
                                dispatch(
                                    authActions.setUnauthorizedUser(
                                        data.message
                                    )
                                );
                                return;
                            }
                            logout();
                            return;
                        }
                    }
                    dispatch(
                        dealAction.saveDigitalAmenitiesDeals({
                            url: digitalUrl,
                            deals: data?.content || []
                        })
                    );
                    setDigitalAmenities(data.content || []);
                }
            );
        }
    };
    // const getExclusiveRewards = () => {
    //     if (isRewards) {
    //         fetchRewards(
    //             {
    //                 isEncryptedResponse: isAuthenticated ? true : false,
    //                 url: `/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=50&categoryList=1,2,3,5&rewardsPage=true`,
    //                 method: 'get',
    //                 isFormData: true
    //             },
    //             (res) => {
    //                 console.log('exclusive Rewards', res?.content);
    //                 setRewards(res?.content);
    //             }
    //         );
    //     }
    // };

    const getRewards = () => {
        const oldCartData = localStorage.getItem('cartData');
        // console.log('current selecttag', selectedTag);
        let cartData = {
            cartValues: [],
            totalMrp: 0,
            totalProduct: 0,
            totalPoints: 0
        };
        if (oldCartData) {
            cartData = JSON.parse(oldCartData);
        }
        console.log('REWARD API CALL');
        if (isRewards) {
            fetchrewards(
                {
                    isEncryptedResponse: isAuthenticated ? true : false,
                    url: `/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=100&rewardsPage=true${
                        searchInput.length > 0
                            ? `&searchValue=${searchInput}`
                            : ''
                    } ${
                        selectedRewardCategory
                            ? `&rewardCategories=${selectedRewardCategory}`
                            : ''
                    }${
                        cartData.totalPoints > 0
                            ? `&cartValue=${cartData.totalPoints}`
                            : ''
                    }`,
                    method: 'get',
                    isFormData: true
                },
                (res) => {
                    console.log(
                        ' Rewards',
                        totalRewardspoint - cartData.totalPoints
                    );
                    // console.log("rewards from data" , res?.content)
                    dispatch(authActions.setTotalRewards(res?.content?.length));
                    if (res?.status == 'FAILED') {
                        setrewards([]);
                        return;
                    }
                    if (totalRewardspoint > 0) {
                        const filteredRewards = res?.content?.filter((val) => {
                            console.log(
                                'deal value',
                                val.points,
                                'remaining points',
                                totalRewardspoint - cartData.totalPoints
                            );
                            return (
                                val.points <=
                                totalRewardspoint - cartData.totalPoints
                            );
                        });
                        setrewards(filteredRewards);
                    } else {
                        setrewards(res?.content);
                    }

                    setIsRewardsLoaded(true);
                }
            );
        }
    };
    // const getTags = () => {
    //     cmsClient({
    //         method: 'GET',
    //         url: `/cms_service/tags/getAll?categoryId=2`
    //     }).then((res) => {
    //         console.log(res);
    //         let tagList = res?.data?.content?.filter((item) =>
    //             [79, 80, 81, 82, 85, 86].includes(item.id)
    //         );
    //         setTagList(tagList);
    //         // console.log("Rewards tagList" , tagList);
    //     });
    // };

    const getRewardCategories = () => {
        let url;
        if (isAuthenticated) {
            url = `winnre/user/reward-categories/getAllByFilter?`;
        } else {
            url = `cms_service/reward-categories/getAllByFilter?clientId=${config?.id}$`;
        }
        const method = 'get';
        url = url + 'pageSize=100';

        fetchRewardsCategory(
            {
                isEncryptedResponse: isAuthenticated ? true : false,
                url,
                method,
                isFormData: true
            },
            (data) => {
                console.log('Rewards Category', data?.content);
                if (data?.status == 'FAILED') {
                    setRewardsCategoryList([]);
                    return;
                }
                setRewardsCategoryList(data?.content);
            }
        );
    };

    useEffect(() => {
        if (isRewards && isAuthenticated) {
            getRewardCategories();
        }
    }, [isAuthenticated, isRewards]);

    useEffect(() => {
        if (isRewards) {
            setTopOffers([]);
        }
    }, [isRewards]);

    useEffect(() => {
        //FIROZ
        // setTopOffers([]);
        // getTags();
        if (totalRewardspoint == null) {
            return;
        }
        getRewards();
    }, [
        isRewards,
        isAuthenticated,
        isRewardRefreshing,
        totalRewardspoint,
        // selectedTag
        selectedRewardCategory
    ]);

    const checkKYCStatus = () => {
        getKYCStatus().then((res) => {
            console.log('returned from get KYC Status', res);
            setKycStatus(res.message);
        });
    };

    useEffect(() => {
        if (isRewards) {
            return;
        }
        if (isBundle) {
            getBundleOffers();
            return
        }

        getTopOffers();
        getVendors();
        getLifestyleOffers();
        getFinanceOffers();
        getExternalOffers();
        getMoveInOffers();
        getDigitalAmenities();
      
    }, [isRewards, isAuthenticated, isBundle]);

    useEffect(() => {
        if (isRewards && isAuthenticated) {
            checkKYCStatus();
        }
    }, [isRewards, isAuthenticated]);

    return {
        bundleOffers,
        topOffers,
        benefits,
        financeOffers,
        externalOffers,
        moveInOffers,
        digitalAmenities,
        vendors,
        isLoadingTopDeals,
        isLoadingBenefits,
        isLoadingFinance,
        isLoadingExternal,
        isLoadingMovein,
        isLoadingDigital,
        error,
        unauthorizedUserMessage,
        handleChange,
        searchInput,
        kycStatus,
        isLoadingBundle,
        rewards,
        isLoadingrewards,
        // tagList,
        // selectedTag,
        // setSelectedTag,
        getRewards,
        isRewardsLoaded,
        totalRewardspoint,
        rewardsCategoryList,
        selectedRewardCategory,
        setSelectedRewardCategory
        // totalPages,
        // setCurrentPage,
        // currentPage
    };
};

export default useData;
